import { en } from 'vuetify/src/locale'

export default {
    ...en,

    login: "Login",
    logout: "Logout",

    add: "Add",
    create: "Create",
    save: "Save",
    cancel: "Cancel",

    user: {
        createNewAdministrator: "Create new administrator"
    },
/*    subgroup: {
        key3: "key 3"
    }*/
}